import React, { useState, createContext, useContext } from 'react';
interface User {
  name: string;
  email: string;
  company: string;
}
interface AuthState {
  role: 'supplier' | 'internal' | null;
  user: User | null;
  login: (role: 'supplier' | 'internal') => void;
  logout: () => void;
}
const AuthContext = createContext<AuthState | null>(null);
export const AuthProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [role, setRole] = useState<'supplier' | 'internal' | null>(null);
  const [user, setUser] = useState<User | null>(null);
  const login = (newRole: 'supplier' | 'internal') => {
    setRole(newRole);
    setUser({
      name: newRole === 'supplier' ? 'James Supplier' : 'Sarah Internal',
      email: newRole === 'supplier' ? 'james@oceanic.com' : 'sarah@fairprice.com',
      company: newRole === 'supplier' ? 'Oceanic Harvest Pte Ltd' : 'FairPrice Group'
    });
  };
  const logout = () => {
    setRole(null);
    setUser(null);
  };
  return <AuthContext.Provider value={{
    role,
    user,
    login,
    logout
  }} data-id="element-249">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};